import React from "react";

import ProductDetailsComponent from "../components/ProductDetailsComponent";

export default function ProductDetails() {
    return (
        <div>
            <ProductDetailsComponent productName="Motorola Edge 20" productDesc="Moto Edge 20 blanco
Cámara trasera 108MP + 16MP (wide/macro) + Cámara Frontal 32 MP, LED flash, Procesador 8 Núcleos + 6 GB RAM
Procesador Qualcomm, Snapdragon 778G Octacore, Quad Kryo Gold @2.4 GHz, Quad Kryo Silver @1.8 GHz
Pantalla 6.67 resolución 1080 x 2400, 394ppi, HID, 144 Hz, tipo pOLED
Tamaño de pantalla: 6.67 inches; Tipo de pantalla: OLED" productImg="https://m.media-amazon.com/images/I/41eA1f1FoWL._AC_.jpg" />
        </div>
    );
}